import { api } from '../api'

interface LoginResult {
  ok: boolean
}

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Checks the password before the console keeps it. Without this the first wrong
     * password would be stored and then fail on whatever screen the operator opened
     * next, which reads as a broken console rather than a typo.
     */
    login: build.mutation<LoginResult, string>({
      query: (password) => ({ url: '/auth/login', method: 'POST', body: { password } }),
    }),
  }),
})

export const { useLoginMutation } = authApi
